import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import addLogDocument from "../addLogDocument.js"; // Custom logging function
import JSZip from "jszip"; // To handle zip file extraction
import { checkDB } from "../../models/DataFunctions.js";

const extractXmlBoth = async (
  url,
  token,
  orgData,
  phone,
  folderId,
  email,
  address,
  name,
  oid,
  prefix,
  new_model = false
) => {
  let urlInsulator = "";
  let sign_coords = { isolant: [], carbone: [] };

  try {
    const start = new Date();

    const currentUser = getAuthCentral().currentUser;
    if (!currentUser) {
      throw new Error("User is not authenticated");
    }

    // Download the file
    const fileResponse = await fetch(url);
    if (!fileResponse.ok) {
      throw new Error(`Failed to download file: ${fileResponse.status}`);
    }

    const fileBytes = await fileResponse.arrayBuffer();
    const zip = await JSZip.loadAsync(fileBytes); // Load ZIP file
    let xmlContent = null;

    // Extract the first XML file from the ZIP
    for (const filename in zip.files) {
      if (filename.endsWith(".xml") && !filename.includes("/")) {
        xmlContent = await zip.file(filename).async("string");
        break;
      }
    }

    if (!xmlContent) {
      throw new Error("No XML file found in the ZIP archive");
    }

    const fileBlob = new Blob([xmlContent], { type: "application/xml" }); // Convert XML content to Blob

    // Process the Insulator XML
    const extractUrl = `${prefix}folders/${folderId}/xml/extract`;
    const formDataInsulator = new FormData();
    formDataInsulator.append("file", fileBlob, "extracted.xml");

    const pdfUrl = `${prefix}folders/${folderId}/xml/generate_pdf`;

    const logo =
      orgData.config?.ath?.hide_my_logo === true
        ? null
        : orgData.logo || "https://i.ibb.co/8Nc2tS4/Placeholder.png";

    const pdfBody = {
      footer: `${name} - ${address}\nTéléphone : ${phone} - Mail : ${email}`,
      type: "insulator",
      oid: oid,
      batch: null,
      logo: logo,
      new_model: new_model,
    };
    formDataInsulator.append("request", JSON.stringify(pdfBody));

    const pdfResponse = await fetch(pdfUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formDataInsulator,
    });

    const userRef = doc(getFirestore(), "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));
    const org_id = userSnapshot.get("org_id");
    const responseText = await pdfResponse.text();

    const end = new Date();
    const elapsed = end - start;

    // Log the Insulator PDF generation
    await addLogDocument(
      pdfUrl,
      prefix,
      userRef,
      org_id,
      pdfResponse.status.toString(),
      "",
      "",
      JSON.stringify(pdfBody),
      responseText,
      "POST",
      elapsed
    );

    if (pdfResponse.ok) {
      // convert to JSON
      const pdfData = JSON.parse(responseText);
      const url = pdfData.url.trim().replace(/"/g, "");
      sign_coords["isolant"] = pdfData.sign_coords.isolant;
      // get url and sign_coords from dict

      urlInsulator = url;
    } else {
      throw new Error("Failed to generate PDF for insulator");
    }

    // Process the Carbon XML
    const formDataCarbon = new FormData();
    formDataCarbon.append("file", fileBlob, "carbon.xml");
    formDataCarbon.append("type", "carbon");

    const carbonResponse = await fetch(extractUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formDataCarbon,
    });

    if (carbonResponse.ok) {
      const jsonResponse = await carbonResponse.json();
      const items = jsonResponse.items;

      const list = items.map((item) => {
        return {
          X: item.index,
          num: item.sous_lot,
          nom: item.nom,
          id: item.identifiant,
          qt: item.quantité,
          un: item.unité,
        };
      });

      return {
        list,
        urlInsulator: urlInsulator,
        sign_coords: sign_coords,
      };
    } else {
      throw new Error("Failed to process carbon XML");
    }
  } catch (error) {
    console.error("Error occurred during XML extraction:", error);
    return { list: [], urlInsulator: "", sign_coords: [] };
  }
};

export default extractXmlBoth;
